export default class Webcam {
    constructor(width = 224, height = 224, isFlip = true) {
        this.width = width;
        this.height = height;
        this.isFlip = isFlip;
        this.isStop = false;
        this.fps = 30;
        this.deviceId = null;
        this.devices = null;
        this.device = null;
        this._stop = false;
        this.permission = true;

        const devicechangeEvt = () => {
            this.getDevices().then(devices => {
                if (devices.length === 0) {
                    this.deviceId = null;
                } else {
                    const isDisconnect = ! devices.find((device) => {
                        return device.deviceId === this.deviceId;
                    })
                    if(isDisconnect) {
                        this.play();
                    }
                }
            })
        }

        navigator.mediaDevices.addEventListener('devicechange', devicechangeEvt);
        navigator.permissions.query({ name: 'camera' }).then(function(permissionStatus) {
            permissionStatus.onchange = function() {
                devicechangeEvt()
            };
        }).catch(function(error) {
            console.error('Error checking camera permission:', error);
        });
    }

    async set(deviceId, fps = null){
        const getDevice = async (deviceId) => {
            const video = document.createElement('video');
            await window.navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: deviceId, 
                    frameRate: 20,
                }
            });
            const mediaStream = await window.navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: deviceId, 
                    frameRate: 24,
                }
            });
            video.srcObject = mediaStream;
            return video;
        }

        const camera = await getDevice(deviceId)
        camera.play();
        this.deviceId = deviceId
        this.device = camera;
    }

    async getDevices(){
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(function(device) {
            return device.kind === 'videoinput';
        });
        this.devices = videoDevices
        return videoDevices
    }

    play() {
        this.isStop = false
        this._stop = false
        this.getDevices().then(async devices => {
            if (devices.length > 0 ) {
                await this.set(devices[0].deviceId)
                this.permission = true;
            } else {
                throw new Error('No Device Detected');
            } 
        }).catch((error) => {
            if (error.message == 'Permission denied') {
                this.permission = false
            }
            if (error.message == 'No Device Detected') {
                //this.permission = false
            }
            setTimeout(() => {
                this.play()
            })
        })
    }

    stop() {
        this.isStop = true;
        if (this.device) {
            const stream = this.device.srcObject;
            stream.getTracks().forEach((track) => {
                track.stop();
            });
            this.device.srcObject = null;
            this.device = null;
        } else {
            console.log('123')
        }
    }

    flip(){
        this.isFlip = !this.isFlip
    }

    cropTo(image, size, flipped = false, canvas = document.createElement('canvas')){
        // image image, bitmap, or canvas
        let width = image.width;
        let height = image.height;

        // if video element
        if (image instanceof HTMLVideoElement) {
            width = image.videoWidth;
            height = image.videoHeight;
        }

        const min = Math.min(width, height);
        const scale = size / min;
        const scaledW = Math.ceil(width * scale);
        const scaledH = Math.ceil(height * scale);
        const dx = scaledW - size;
        const dy = scaledH - size;
        canvas.width = canvas.height = size;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, ~~(dx / 2) * -1, ~~(dy / 2) * -1, scaledW, scaledH);

        // canvas is already sized and cropped to center correctly
        if (flipped) {
            ctx.scale(-1, 1);
            ctx.drawImage(canvas, size * -1, 0);
        }

        return canvas;
    }

    update() {
        if (this.device && this.device.srcObject.active) {
            const croppedCanvas = this.cropTo(this.device, this.width, this.isFlip);
            return croppedCanvas
        } else {
            if (!this.isStop) {
                this.play()
            }
            return null
        }
    }

    loop(callback = ()=>{}){
        let last = Date.now()
        this._stop = false

        const loop = async () => {
            const interval = 1000 / this.fps;
            if ( Date.now() - last >= interval && this.device ) {
                last = Date.now();
                const croppedCanvas = this.update();
                callback(croppedCanvas)
            }
            if (!this._stop) {
                window.requestAnimationFrame(loop)
            }
        }

        loop();
    }

    stopLoop(){
        this._stop = true
    }
}